/**
 * Позиция заказа так, как она лежит в Firestore: цена блюда + выбранные гостем
 * допы. Каталожное поле `addons` (что у блюда вообще можно выбрать) в заказ
 * попадает вместе со спредом MenuItem — показывать его гостю как «заказано»
 * нельзя, читаем только `selectedAddons`.
 */
interface PricedItem {
  price?: number;
  quantity?: number;
  selectedAddons?: Array<{ price?: number }>;
}

/** Сумма выбранных допов на одну порцию. */
export function addonsPrice(item: PricedItem): number {
  return (item.selectedAddons || []).reduce((sum, a) => sum + (Number(a.price) || 0), 0);
}

/**
 * Стоимость строки заказа с допами и количеством — та же формула, что в
 * корзине (CartContext.totalPrice). Иначе строки не сходятся с итогом чека.
 */
export function lineTotal(item: PricedItem): number {
  return ((Number(item.price) || 0) + addonsPrice(item)) * (Number(item.quantity) || 1);
}
